import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { VuiHttpService } from '../../../../vui-http/src/lib/http-wrapper/vui-http.service';


@Pipe({
    name: 'secureLoad',
    standalone: false
})
export class SecureLoadPipe implements PipeTransform {
  constructor(
    private vuiHttpService: VuiHttpService,
    private sanitizer: DomSanitizer,
  ) {}

  transform(url: string): Observable<any> {
    return (
      this.vuiHttpService
        .get(url, { responseType: 'blob' })
        // create an object url of that blob that we can use in the src attribute
        .pipe(
          mergeMap((blobImg: Blob) => {
          return new Observable<string | null>(observer => {
            if (blobImg) {
              const reader = new FileReader();
              reader.readAsDataURL(blobImg);
              reader.onload = () => {
                const sanitizedResult = this.sanitizer.sanitize(SecurityContext.URL, reader.result as string);
                observer.next(sanitizedResult);
                observer.complete();
              };
              reader.onerror = (error) => {
                observer.error(error);
              };
            } else {
              observer.next(null);
              observer.complete();
            }
          });
        })
      )
    );

    // return new Observable<any>(observer => {
    //   const { next, error } = observer;
    //   observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

    //   this.vuiHttpService.get(url, { headers, responseType: 'blob' }).subscribe(
    //     (response: any) => {
    //       const reader = new FileReader();
    //       const dataType = response.type;
    //       reader.readAsDataURL(response);
    //       reader.onloadend = () => {
    //         observer.next(this.sanitizer.bypassSecurityTrustUrl(reader.result as string));
    //       };
    //     },
    //     err => {
    //       this.notifierService.error(err.message);
    //     },
    //   );

    //   return {
    //     unsubscribe(): any {},
    //   };
    // });
  }
}
